var _linearGradient, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailwindcss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1504,
    preserveAspectRatio: "xMidYMid",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 153.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "-2.778%",
    y1: "32%",
    y2: "67.556%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2298bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ed7b5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0C93.867 0 72.533 17.067 64 51.2 76.8 34.133 91.733 27.733 108.8 32c9.737 2.434 16.697 9.499 24.401 17.318C145.751 62.057 160.275 76.8 192 76.8c34.133 0 55.467-17.067 64-51.2-12.8 17.067-27.733 23.467-44.8 19.2-9.737-2.434-16.697-9.499-24.401-17.318C174.249 14.743 159.725 0 128 0zM64 76.8C29.867 76.8 8.533 93.867 0 128c12.8-17.067 27.733-23.467 44.8-19.2 9.737 2.434 16.697 9.499 24.401 17.318C81.751 138.857 96.275 153.6 128 153.6c34.133 0 55.467-17.067 64-51.2-12.8 17.067-27.733 23.467-44.8 19.2-9.737-2.434-16.697-9.499-24.401-17.318C110.249 91.543 95.725 76.8 64 76.8z",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindcss);
export default __webpack_public_path__ + "static/media/tailwindcss.68603ef4173093c409dcd59733df7ecf.svg";
export { ForwardRef as ReactComponent };